import type { FindIngestionsResponseDto } from "./FindIngestionsResponseDto"

export const findIngestionsHttpControllerFindIngestionsQueryParamsStatus = {
  PENDING: "PENDING",
  BLANK_PRODUCTS_VERIFIED: "BLANK_PRODUCTS_VERIFIED",
  BLANK_PRODUCTS_INGESTED: "BLANK_PRODUCTS_INGESTED",
  PRODUCTS_VERIFIED: "PRODUCTS_VERIFIED",
  PRODUCTS_INGESTED: "PRODUCTS_INGESTED",
  PROCESSED: "PROCESSED",
  ERROR: "ERROR",
  FAILED: "FAILED",
} as const
export type FindIngestionsQueryParamsStatus =
  (typeof findIngestionsHttpControllerFindIngestionsQueryParamsStatus)[keyof typeof findIngestionsHttpControllerFindIngestionsQueryParamsStatus]
export type FindIngestionsQueryParams = {
  /**
   * @type string | undefined
   */
  status?: FindIngestionsQueryParamsStatus
  /**
   * @type string | undefined
   */
  emailLauncher?: string
}
export type FindIngestions200 = FindIngestionsResponseDto[]
export type FindIngestionsQueryResponse = FindIngestionsResponseDto[]
export type FindIngestionsQuery = {
  Response: FindIngestionsQueryResponse
  QueryParams: FindIngestionsQueryParams
}
